@if (displayChipList()) {
  <div class="chip-list-wrapper">
    <mat-chip-listbox #chipList>
      @for (select of selectData; track select) {
        <mat-chip class="cardinal-colors" (click)="removeChip(select)">
          {{ select.item }}
          <mat-icon class="mat-chip-remove">cancel</mat-icon>
        </mat-chip>
      }
    </mat-chip-listbox>
  </div>
}

<mat-form-field appearance="fill" class='w-full btn-select'>
  <input matInput type="text" [placeholder]="placeholder()" [matAutocomplete]="auto" [formControl]="selectControl">
</mat-form-field>

<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
  <!-- <mat-optgroup *ngFor="let group of filteredData | async" [label]="group ? group.name : ''"> -->
  @for (data of filteredData | async; track data) {
    <mat-option>
      <div (click)="optionClicked($event, data)">
        <mat-checkbox [checked]="data.selected" [disabled]="data.disabled" (change)="toggleSelection(data)" (click)="$event.stopPropagation()">
          {{ data.item }}
        </mat-checkbox>
      </div>
    </mat-option>
  }
</mat-autocomplete>